import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shouldRefetchMembershipCarousels: false,
};

const membershipHomeCarouselsSlice = createSlice({
  name: "membershipHomeCarousels",
  initialState,
  reducers: {
    setShouldRefetchMembershipCarousels: (state, action) => {
      state.shouldRefetchMembershipCarousels = action.payload;
    },
  },
});

export const { setShouldRefetchMembershipCarousels } = membershipHomeCarouselsSlice.actions;
export const actionTypes = {
  SET_SHOULD_REFETCH_MEMBERSHIP_CAROUSELS: `${membershipHomeCarouselsSlice.name}/setShouldRefetchMembershipCarousels`,
};

export default {
  types: actionTypes,
  fn: membershipHomeCarouselsSlice.reducer,
};
